import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enTranslation from '../public/locales/en/translation.json';
import esTranslation from '../public/locales/es/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      es: { translation: esTranslation },
    },
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    // Support for pluralization
    pluralSeparator: '_',
    // Ensure missing translations fallback to English with console warning
    saveMissing: true,
    missingKeyHandler: (lngs, _ns, key) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`[i18n] Missing translation key: ${key} for language: ${lngs[0]}`);
      }
    },
  });
